import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { Filters } from '../constants/filter/filters';
import { FilterActions } from '../constants/filter/filter_actions';

class CatalogConditionalOptionsStoreClass extends ReduceStore {
    getInitialState() {
        const initialState = {};
        initialState[Filters.FREE_FITTING] = false;
        initialState[Filters.BUY_4_PAY_3] = false;
        initialState[Filters.CLEARANCE] = false;
        initialState[Filters.INSTANT_CASH] = false;
        initialState[Filters.RUN_FLAT] = false;

        initialState[Filters.DISCOUNT_INSTANT_CASH_50] = false;
        initialState[Filters.DISCOUNT_INSTANT_CASH_80] = false;
        initialState[Filters.DISCOUNT_INSTANT_CASH_100] = false;
        initialState[Filters.DISCOUNT_INSTANT_CASH_120] = false;
        initialState[Filters.DISCOUNT_INSTANT_CASH_150] = false;
        initialState[Filters.DISCOUNT_INSTANT_CASH_160] = false;
        initialState[Filters.DISCOUNT_INSTANT_CASH_200] = false;
        initialState[Filters.DISCOUNT_INSTANT_CASH_250] = false;
        initialState[Filters.DISCOUNT_INSTANT_CASH_300] = false;
        initialState[Filters.DISCOUNT_5_OFF] = false;
        initialState[Filters.DISCOUNT_10_OFF] = false;
        initialState[Filters.DISCOUNT_15_OFF] = false;
        initialState[Filters.DISCOUNT_20_OFF] = false;
        initialState[Filters.DISCOUNT_25_OFF] = false;
        initialState[Filters.PROMO_GIFT_CARD_50] = false;
        initialState[Filters.PROMO_GIFT_CARD_80] = false;
        initialState[Filters.PROMO_GIFT_CARD_100] = false;
        initialState[Filters.PROMO_GIFT_CARD_130] = false;
        initialState[Filters.PROMO_GIFT_CARD_150] = false;
        initialState[Filters.PROMO_GIFT_CARD_200] = false;
        initialState[Filters.PROMO_GIFT_CARD_250] = false;

        initialState[Filters.QUALITY_SEGMENT_PREMIUM] = false;
        initialState[Filters.QUALITY_SEGMENT_VALUE] = false;
        initialState[Filters.QUALITY_SEGMENT_BUDGET] = false;

        return initialState;
    }

    reduce(state, {source, action}) {
        if (source === ACTION_TYPES.CATALOG_CONDITIONAL_OPTIONS_ACTION) {
            switch (action.type) {
                case FilterActions.ENABLE_OPTION:
                    if (
                        typeof state[action.payload] !== 'undefined' &&
                        !state[action.payload]
                    ) {
                        state[action.payload] = true;
                        this.__emitChange();
                    }

                    break;
                case FilterActions.DISABLE_OPTION:
                    if (
                        typeof state[action.payload] !== 'undefined' &&
                        state[action.payload]
                    ) {
                        state[action.payload] = false;
                        this.__emitChange();
                    }

                    break;
            }
        }

        return state;
    }
}

const CatalogConditionalOptionsStore = new CatalogConditionalOptionsStoreClass(Dispatcher);
export default CatalogConditionalOptionsStore;